import React, { useState } from "react";
import WelcomeBanner from "@/components/dashboard/WelcomeBanner";
import QuickActions from "@/components/dashboard/QuickActions";
import TodaysSchedule from "@/components/dashboard/TodaysSchedule";
import UpcomingAppointments from "@/components/dashboard/UpcomingAppointments";
import TasksList from "@/components/dashboard/TasksList";
import UpcomingDeadlines from "@/components/dashboard/UpcomingDeadlines";
import ClientRequests from "@/components/dashboard/ClientRequests";
import NotificationsArea from "@/components/dashboard/NotificationsArea";
import PendingRequestsCard from "@/components/dashboard/PendingRequestsCard";
import BillingOverviewCard from "@/components/dashboard/BillingOverviewCard";

export default function Dashboard() {
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = () => setRefreshKey((k) => k + 1);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-5 lg:gap-6">
        <div className="col-span-1 md:col-span-8 lg:col-span-12">
          <WelcomeBanner refreshKey={refreshKey} onQuickAction={bump} />
        </div>

        <div className="col-span-1 md:col-span-8 lg:col-span-4">
          <QuickActions onCreated={bump} />
        </div>
        <div className="col-span-1 md:col-span-4 lg:col-span-4">
          <TodaysSchedule refreshKey={refreshKey} />
        </div>
        <div className="col-span-1 md:col-span-4 lg:col-span-4">
          <UpcomingAppointments refreshKey={refreshKey} />
        </div>

        <div className="col-span-1 md:col-span-8 lg:col-span-7">
          <TasksList refreshKey={refreshKey} onChange={bump} />
        </div>
        <div className="col-span-1 md:col-span-8 lg:col-span-5">
          <UpcomingDeadlines />
        </div>

        <div className="col-span-1 md:col-span-4 lg:col-span-6">
          <ClientRequests refreshKey={refreshKey} />
        </div>
        <div className="col-span-1 md:col-span-4 lg:col-span-6">
          <PendingRequestsCard refreshKey={refreshKey} onChange={bump} />
        </div>
        <div className="col-span-1 md:col-span-8 lg:col-span-12">
          <BillingOverviewCard />
        </div>
        <div className="col-span-1 md:col-span-8 lg:col-span-12">
          <NotificationsArea />
        </div>
      </div>
    </div>
  );
}
